import { Map as CianMap } from '@cian/frontend-newbuilding-map-component';
import { IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import { RoundButton } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { MapOfferCardContainer } from '../../containers/MapOfferCardContainer';
import { ICoordinates } from '../../types/geo';
import { EType, TInfrastructurePin } from '../../types/map';
import { InfrastructureMapTypes } from '../InfrastructureMapTypes';

export const CENTER_OF_MOSCOW = { lat: 55.751244, lng: 37.618423 };

interface IMapProps {
  types: string[];
  apiKey: string;
  infrastructurePins: TInfrastructurePin[];
  infrastructureTypes: { title: string; type: EType }[];
  coordinates?: ICoordinates;
  handleGeoObjectsFirstFetch: () => Promise<IGeoObject[]>;
  handleBalloonHtmlFirstFetch: (geoObject: IGeoObject) => Promise<string>;
  handleGeoClick: (geoObject: IGeoObject) => void;
  handleClose: () => void;
  setInfrastructureType: (type: string) => void;
}

export const Map: React.FC<IMapProps> = ({
  types,
  apiKey,
  infrastructurePins,
  infrastructureTypes,
  coordinates,
  handleGeoObjectsFirstFetch,
  handleBalloonHtmlFirstFetch,
  handleGeoClick,
  handleClose,
  setInfrastructureType,
}) => {
  return (
    <div className={styles['container']}>
      <CianMap
        geoObjectNames={types}
        firstPaintOptions={{
          apiKey,
          fetch: { onGeoObjectsFetch: handleGeoObjectsFirstFetch, onBalloonHtmlFetch: handleBalloonHtmlFirstFetch },
          styles: { width: '100%', height: '100vh' },
          controls: [{ type: 'ZoomControl' }, { type: 'RulerControl' }],
          zoomRange: { min: 1, max: 50 },
          clusters: { clusterize: true, gridSize: 10, iconColor: 'rgba(4, 104, 255, 1)' },
          onGeoObjectClick: handleGeoClick,
        }}
        media={[
          {
            minWidth: -Infinity,
            maxWidth: Infinity,
            options: {
              center: coordinates || CENTER_OF_MOSCOW,
              styles: { width: '100%', height: '100vh' },
              animationDuration: 300,
              defaultZoom: 12,
            },
          },
        ]}
      />
      <div className={styles['close-button']} data-testid="close_button">
        <RoundButton
          title="Закрыть карту"
          theme="fill_dark"
          size="M"
          onClick={handleClose}
          icon={<IconActionClose16 color="icon-inverted-default" />}
        />
      </div>
      <MapOfferCardContainer />
      {infrastructurePins.length && (
        <InfrastructureMapTypes
          types={infrastructureTypes}
          currentTypes={types}
          setType={setInfrastructureType}
          isFullscreen
        />
      )}
    </div>
  );
};
